import { connect } from "react-redux";
import { getFilteredTournamentsForList, getTournamentsForList } from "../selectors";
import LobbyTournamentList from "../containers/lobby-tournament-list";
import React from "react";
import TournamentListBanner from "../containers/tournament-list-banner";

function HomePage({ filteredTournaments, location, match, tournaments }) {
  return (
    <div>
      <div className="marquee">
        <div className="l-row l-row--brand-color">
          <div className="l-wrapper">
            <div className="batch-g batch-g--align-center">
              <TournamentListBanner list={match.params.list} />
            </div>
          </div>
        </div>
      </div>

      <LobbyTournamentList
        filteredTournaments={filteredTournaments}
        list={match.params.list}
        location={location}
        page={match.params.page}
        tournaments={tournaments} />
    </div>
  );
}

function select(state, props) {
  return {
    tournaments: getTournamentsForList(state, props),
    filteredTournaments: getFilteredTournamentsForList(state, props)
  };
}

export default connect(select)(HomePage);
